import {Store} from '@ngrx/store';
import {Injectable, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import * as PtCoreActions from '../store/actions/pt-core.actions';
import * as PtCoreSelectors from '../store/selectors/pt-core.selectors';
import {SessionInfoType, SessionNotification} from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class AppPolling implements OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private downloadInterval: unknown = undefined;
  private pollingTime = 10000; //moved from env
  private downloadSessionNotification: SessionNotification[];
  public sessionNotifications$ = this.store.select(PtCoreSelectors.sessionNotifications);
  constructor(private store: Store) {}

  ngOnDestroy(): void {
    this.reset();
    this.destroy$.next(true);
  }

  private reset() {
    this.downloadSessionNotification = [];
    if (this.downloadInterval && Number.isInteger(this.downloadInterval)) {
      clearInterval(this.downloadInterval as number);
      this.downloadInterval = null;
    }
  }

  public stop() {
    this.reset();
  }

  public start() {
    this.reset();
    this.sessionNotifications$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((notification: SessionNotification[]) => {
      if (notification) {
        // this.downloadSessionNotification = notification;
        this.downloadSessionNotification = notification.filter((n) => n?.actionType === SessionInfoType.DOWNLOAD);
      } else {
        this.downloadSessionNotification = [];
      }
    });

    this.downloadInterval = setInterval(() => {
      const downloadIds: string[] = this.getDownloadId();
      if (downloadIds?.length > 0) {
        this.store.dispatch(PtCoreActions.getDownloadStatus({ downloadIds }));
      }
    }, this.pollingTime);

  }


  private getDownloadId(): string[] {
    if (this.downloadSessionNotification?.length > 0) {
      return this.downloadSessionNotification
        .filter((n) => n.status !== 'COMPLETED' && n.status !== 'ERROR')
        .map((n) => n.payload?.uuid)
        .filter((uuid) => !!uuid);
    }
    return [];
  }

}
